import { formatUTCDate } from 'core';
import {
  Prs, PrsComponent
} from "store/post-results-services/postResultsServicesApi";

import { BcCheckbox } from '@britishcouncil/react-solas-ors3';

import { StatusLabel } from '../StatusLabel/StatusLabel';

import * as S from './ServiceCard.style';
import { getTaxInfo } from 'pages/helper/taxInfo';

export type ServiceCardProps = {
  data: Prs;
  cardId?: string;
  title?: string;
  displayCheckbox?: boolean;
  deadlinePassed: boolean;
  onChangeCheckbox?: (checked: boolean) => void;
  checkboxValue?: boolean;
  items?: PrsComponent[];
};

export const ServiceCard = ({ data, displayCheckbox, onChangeCheckbox, checkboxValue = false, deadlinePassed = false }: ServiceCardProps) => {
  const handleChangeCheckbox = (checked: boolean) => {
    if (onChangeCheckbox) {
      onChangeCheckbox(checked);
    }
  };

  return (
    <S.ServiceCard>
      <S.InfoContainer>
        {displayCheckbox && (
          <BcCheckbox
                      style={{'zIndex': 0}}
                      background="gray" 
                      handleChange={handleChangeCheckbox} 
                      checked={checkboxValue} 
                      disabled={deadlinePassed} 
                      data-tooltip-id={deadlinePassed ? `deadline-passed-${data.id}` : ''}/>
        )}

        <S.InfoContainerData>
          <S.ItemRow>
            <S.ItemRowLabel>Exam:</S.ItemRowLabel>
            <S.ItemRowValue className="title-value">{data.exam}</S.ItemRowValue>
          </S.ItemRow>

          {data.referenceId && (
            <S.ItemRow>
              <S.ItemRowLabel>Post results services reference ID:</S.ItemRowLabel>
              <S.ItemRowValue>{data.referenceId}</S.ItemRowValue>
            </S.ItemRow>
          )}

          {data.qualificationLevelName && (
            <S.ItemRow>
              <S.ItemRowLabel>Qualification Level:</S.ItemRowLabel>
              <S.ItemRowValue>{data.qualificationLevelName}</S.ItemRowValue>
            </S.ItemRow>
          )}

          {data.serviceTypeName && (
            <S.ItemRow>
              <S.ItemRowLabel>Post result service type:</S.ItemRowLabel>
              <S.ItemRowValue>{data.serviceTypeName}</S.ItemRowValue>
            </S.ItemRow>
          )}

          {data.createdOn && (
            <S.ItemRow>
              <S.ItemRowLabel>Date of creation:</S.ItemRowLabel>
              <S.ItemRowValue>{formatUTCDate(new Date(data.createdOn))}</S.ItemRowValue>
            </S.ItemRow>
          )}
          {data.status && (
              <S.ItemRow>
                <S.ItemRowLabel>Status:</S.ItemRowLabel>
                <S.ItemRowValue>
                  <StatusLabel status={data.status} />
                </S.ItemRowValue>
              </S.ItemRow>
          )}
        </S.InfoContainerData>
      </S.InfoContainer>
      
      <S.ComponentsContainer>
        {data.prsComponents.map((component) => (
          <S.Component key={component.component}>
            <S.ItemRow>
              <S.ItemRowLabel>Component:</S.ItemRowLabel>
              <S.ItemRowValue>{`${component.component}`}</S.ItemRowValue>
            </S.ItemRow>

            <S.ItemRow>
              <S.ItemRowLabel>Price:</S.ItemRowLabel>
              <S.ItemRowValue>
                {component.fee} <br />
                {getTaxInfo(data.taxRate, component.feeValue)}
              </S.ItemRowValue>
            </S.ItemRow>
          </S.Component>
        ))}
      </S.ComponentsContainer>
      
      <S.Tooltip id={`deadline-passed-${data.id}`} 
                 place='bottom' 
                 content={'Please contact your nearest British Council office to cancel the request.'}/>
    </S.ServiceCard>
  );
};